export const todayIsoDate = () => new Date().toISOString().slice(0, 10);

const hasCnos = patient => (patient.cnos || []).length > 0;

export const initialDeliverySelection = patients => new Set(patients.filter(hasCnos).map(patient => patient.id));

// Seuls les patients enregistrés en base et ayant des CNO peuvent être livrés.
export const isDeliverySelectable = patient => typeof patient.id === "number" && hasCnos(patient);

export function toggleSelection(selection, id, checked) {
    const next = new Set(selection);
    if (checked) next.add(id);
    else next.delete(id);
    return next;
}

export function validateDelivery({ deliveryDate, selectedIds }) {
    const patientIds = [...selectedIds].filter(id => typeof id === "number");
    if (!deliveryDate) return { error: "La date de livraison est obligatoire." };
    if (patientIds.length === 0) return { error: "Cochez au moins un patient enregistré avec des CNO." };
    return { patientIds };
}

export const driverLabel = driver => [driver.firstName, driver.lastName].filter(Boolean).join(" ") || driver.email;

export const productCountLabel = count => `${count} produit${count > 1 ? "s" : ""} CNO`;

export const defaultDriverId = drivers => (drivers[0]?.id ? String(drivers[0].id) : "");

export const deliveryErrorMessage = error => error.response?.data?.message || "La livraison CNO n'a pas pu être créée.";
